import { Alert, Text, View, useColorScheme } from 'react-native';
import React, { Suspense, lazy, memo, useState } from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import MenuIconCard from '@components/Global/MenuIconCard';
import { useTranslation } from 'react-i18next';
import { XStack } from 'tamagui';


const AnimatedLottieView = lazy(() => import('@utils/lottieAnimation'));

const LazyLottieView = (props) => (
  <Suspense fallback={<View />}>
    <AnimatedLottieView {...props} />
  </Suspense>
);


const SalesMenu = ({ navigation }) => {
  const { t } = useTranslation();
  return (
    <DefaultScreen style={{ paddingLeft: 2, paddingRight: 3 }}>
      <XStack flexWrap='wrap' gap={20} columnGap={20} style={{ gap: 5, paddingBottom: 150, alignSelf: 'stretch', flexDirection: 'row', flexWrap: 'wrap' }}>
        <MenuIconCard pressFunction={() => navigation.navigate('SalesDashboard')} subtitle={`${t('salesDashSub')}`} cardTitle={`${t('salesDash')}`}>
          <LazyLottieView source={require('@assets/animations/magnifExample.json')} loop={true} style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard new pressFunction={() => navigation.navigate("SocialPosts")} subtitle={`${t('socialMediaSub')}`} cardTitle={`${t('socialMedia')}`}>
          <LazyLottieView source={require('@assets/animations/socials.json')} loop={true} style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard beta pressFunction={() => navigation.navigate("BoostPost")} subtitle="Promote your posts to reach a wider audience" cardTitle="Boost Posts">
          <LazyLottieView source={require('@assets/animations/star.json')} loop={true} style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard new pressFunction={() => navigation.navigate("Media")} subtitle={`${t('mediaSub')}`} cardTitle={`${t('media')}`}>
          <LazyLottieView source={require('@assets/animations/socials.json')} loop={true} style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('ActiveCampaigns')} subtitle={`${t('activeCampaignSub')}`} cardTitle={`${t('activeCampaigns')}`}>
          <LazyLottieView source={require('@assets/animations/star.json')} loop={true} style={{ width: '110%', height: 70, justifyContent: 'center', alignSelf: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('PreviousCampaigns')} subtitle={`${t('prevCampaignSub')}`} cardTitle={`${t('completeCampaigns')}`}>
          <LazyLottieView source={require('@assets/animations/42404-add-document.json')} loop={true} style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
      </XStack>
    </DefaultScreen >
  )
}
export default memo(SalesMenu);